import React, { Component } from 'react';

import cookie from 'react-cookies';

import Input from '../components/Input';

import { Link } from 'react-router';
import { API_BASE } from '../config';

class TokenSignIn extends Component {

  constructor(props) {
    super(props);
    
    this._continueToReturnUrl = this._continueToReturnUrl.bind(this);
    this._grantAccess = this._grantAccess.bind(this);

    this.state = {
      message:"Working...",
      return_url:this.props.params.return_url,
      signedIn:false,
      user_id:0
    };

  }

  componentDidMount() {

    this._grantAccess();

  }

  /*componentWillReceiveProps(newProps) {
    this.setState({
      message:newProps.message
    });
  }*/

  render() {
    
      return (

          <div className="clearfix clearflex">

            <div className="Page App-signIn">
              <h1>Welcome back!</h1>
              <h3>{this.state.message}</h3>
              {this.state.signedIn ? 
                <div>
                  
                  <p>&nbsp;</p><p>Reset your passphrase if you want. Just type a new one below.</p>
                  <p><Input label="New password/passphrase" name="password" hidable value="" endpoint="users" id={this.state.user_id} onSave={this._continueToReturnUrl} /></p>

                  <p>&nbsp;</p>
                  <p>Or, <a href={this.state.return_url ? this.state.return_url : "/"}>skip and continue {this.state.return_url ? "where you left off →"  : "to your stores →"}</a></p>
                </div>
              : ""}
            </div>
            
          </div>

      );
  
  }

  _continueToReturnUrl() {
    setTimeout(function() {
      window.location.href = this.state.return_url ? this.state.return_url : "/";
    }.bind(this),1250);
  }

  _grantAccess() {

    var _this = this;

    var request = new Request(`${API_BASE}auth/login/`+this.props.params.token, {
      method: 'POST', 
      mode: 'cors', 
      headers: new Headers({})
    });

    fetch(request).then(function(response) {
      
      if (response.status === 200) {
        return response.json();
      } else {
        _this.setState({
          message:"😳 Looks like that link is expired..."
        });      
      }
    
    }).then(function(json) {
      
      _this.setState({
          message:"😉 You're in!",
          signedIn:true
      });

      // store some stuff
      localStorage.setItem('user_id',json.id);
      localStorage.setItem('name',json.name);
      localStorage.setItem('email',json.email);
      localStorage.setItem('image','https://image.devidentify.com/'+json.email);
      localStorage.setItem('token',json.token);

      cookie.save("user_id",json.id,{ path : '/'});
      cookie.save("user_id",json.id,{ path : '/', domain : 'reallysimplestore.com'});
      cookie.save("user_token",json.token,{ path : '/'});
      cookie.save("user_token",json.token,{ path : '/', domain : 'reallysimplestore.com'});

      // set timezone offset
      var offset = new Date().getTimezoneOffset();
      localStorage.setItem("timezone_offset",offset);

      //_this.props.router.replace('/'); // remove token from url
      
      _this.setState({ // in case they want to reset password
        user_id:json.id
      })

      //location.href = "/"; // temporarily redirect to account home... in future, use a return parameter

    }).catch(function(ex) {
      console.log('parsing failed', ex);

      _this.setState({
        message:"😳 Oops. Something went wrong..."
      });

    });
  }


}

export default TokenSignIn;



// WEBPACK FOOTER //
// ./src/pages/TokenSignIn.js